import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { AlertService } from '../../_services/alert.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.css']
})
export class SecurityComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();

  groupDesc: string;
  groupCode: string;

  groupDescError: string;
  groupNameError: string;
  totalRecords: number;

  groupList: any = [];
  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, private api: ApiIntegration, private g: Globals, public user: User) {
    this.g.page = "Security Groups";
    this.getAllSecurityType();
  }
  getAllSecurityType() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Name / Description'
      },
      ajax: (dataTablesParameters: any, callback) => {
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getAllSecurityType/1';
        let query: any = {
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.groupList = resp.securityGroups || [];
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };
  }


  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }
  typeGroupName() {
    this.groupNameError = "";
    if (this.groupCode == '' || this.groupCode === null || this.groupCode === undefined || this.groupCode === 'undefined') {
      this.groupNameError = 'please enter group name';
    }
  }
  typeGroupDesc() {
    this.groupDescError = "";
    if (this.groupDesc == '' || this.groupDesc === null || this.groupDesc === undefined || this.groupDesc === 'undefined') {
      this.groupDescError = 'please enter group description';
    }
  }
  submitGroup() {
    this.g.loaderDisplay = "display";
    this.groupNameError = "";
    this.groupDescError = "";

    if (this.groupCode == '' || this.groupCode === null || this.groupCode === undefined || this.groupCode === 'undefined') {
      this.groupNameError = 'please enter group name';
    }
    if (this.groupDesc == '' || this.groupDesc === null || this.groupDesc === undefined || this.groupDesc === 'undefined') {
      this.groupDescError = 'please enter group description';
    }

    if (this.groupNameError != "" || this.groupDescError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createSecurityTypeGroup', {
      "groupDescription": this.groupDesc,
      "groupCode": this.groupCode,
      "organizationId": 1,
      "status": "ACTIVE"
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Security Group', 'Submitted Successfully');
          this.groupCode = "";
          this.groupDesc = "";
          this.getAllSecurityType();
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  changeStatus(n) {
    this.g.loaderDisplay = "display";
    if (n.status == "ACTIVE") {
      n.status = "IN_ACTIVE";
    } else {
      n.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateSecurityGroupStatus', {
      "organizationId": 1,
      "groupName": n.groupCode,
      "status": n.status

    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Group', 'Status Updated Successfully');

      } else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {

        this.g.loaderDisplay = "";
      });

  }
}
